enum EmploymentStatus {
  W2FullTime,
  W2PartTime,
  Owner,
  Other,
}

export default EmploymentStatus
